import base from './Base';

var Modal = (function () {
    'use strict';

    /* Variable inits */
    const openedModals = [];
    const externalModal = base.get('.external-modal');
    const modalContainer = base.get('.modal-container');
    const videoModal = document.querySelectorAll('.videoModal');

    videoModal.forEach(vidModal => {
        vidModal.addEventListener('hide.bs.modal', () => {
            document.querySelectorAll('video').forEach(vid => vid.pause());
        })
    })


    /* Handles Closing Modal */
    const closeModal = () => {
        let currentOpened = openedModals[0];
        base.removeClass(currentOpened, 'open');
        currentOpened.setAttribute('tabindex', '');

        if (openedModals.length < 2) { base.removeClass(modalContainer, 'open'); }
        openedModals.shift();
        openedModals[0].focus();
    };

    /* Handles Opening Modal */
    const openModal = (elem, link) => {
        openedModals.unshift(elem);
        if (link) { elem.querySelector('.continue').setAttribute('href', link); }

        base.addClass(elem, 'open');
        base.addClass(modalContainer, 'open');

        elem.setAttribute('tabindex', '-1');
        elem.focus();
    };

    /* Handles Link Redirect and Modal Close */
    const redirectLink = (elem) => {
        const link = elem.getAttribute('href');
        window.open(link, '_blank');
        closeModal();
    };

    /* Handles Click Event to Find Correct Modal to Open or Close */
    const getModalOpenClose = (e) => {

        const selector = e.target.nodeName.toLowerCase();
        const elem = (selector === 'a') || (selector === 'div') || (selector === 'button') ? e.target : e.target.closest("a");

        if (elem !== null && elem.getAttribute('data-modal')) {
            const link = elem.getAttribute('href');
            const modal = elem.getAttribute('data-modal');
            if (!modal) { return false; }

            e.preventDefault();

            switch (modal) {
                case 'external':
                    openModal(externalModal, link);
                    break;
                case 'download':
                    openModal(downloadModal);
                    break;
                case 'continue':
                    redirectLink(elem);
                    break;
                case 'close':
                    closeModal(elem);
                    break;
            }
        }

    };

    const handleEvents = () => {
        window.addEventListener('click', (e) => { getModalOpenClose(e); });
        window.addEventListener('keydown', (e) => {
            if (event.keyCode === 13) {
                getModalOpenClose(e);
            }
        });

    };


    function init() {
        handleEvents();
    }

    return {
        init: init
    };
}());

export default Modal;
